<template>
  <div v-if="post">
    <header ref="header" class="article-single__header">
      <div class="article-single__content">
        <LangRouterLink :to="{ name: 'post.index' }" class="article-single__link">
          <Icon id="arrow" class="article-single__icon" />
          <span>{{ $t('post.return') }}</span>
        </LangRouterLink>
        <h1 v-scroll:reveal="{ delay: 550 }" class="article-single__title">
          {{ post.title }}
        </h1>
        <h2 v-scroll:reveal="{ delay: 600 }" class="article-single__subtitle">
          {{ $store.getters.post_category(post.category_id)?.name }} -
          {{ formatDate(post.published_at, $i18n.locale) }}
        </h2>
      </div>

      <Image v-if="post.image" :source="post.image" class="article-single__image" />
    </header>

    <section class="section -article-single">
      <div class="section__content">
        <h2 v-if="post.subtitle" class="section__subtitle">
          {{ post.subtitle }}
        </h2>

        <div class="row">
          <RawHtml class="row__item -span-10" :html="post.content" />
        </div>
      </div>

      <div class="share-block --laptop">
        <p class="share-block__label">{{ $t('post.share') }}</p>

        <div class="share-block__links">
          <button class="share-block__button" @click="shareSocials('facebook')">
            <Icon id="facebook" class="share-block__icon" />
            FACEBOOK
          </button>

          <button class="share-block__button" @click="shareSocials('linkedin')">
            <Icon id="linkedin" class="share-block__icon" />
            LINKEDIN
          </button>

          <a
            target="_blank"
            :href="`mailto:?subject=${$t('post.mail.subject')}&amp;body=${$t('post.mail.body')} ${shareUrl}`"
          >
            <button class="share-block__button">
              <Icon id="mail" class="share-block__icon" />
              MAIL
            </button>
          </a>
        </div>
      </div>

      <div v-if="hasShare" class="share-block -news --mobile">
        <div class="share-block__links">
          <button class="share-block__button -news" @click="shareNavigator">
            <Icon id="share" class="share-block__icon" />
            SHARE THIS NEWS
          </button>
        </div>
      </div>
    </section>

    <section class="section -centered -alt">
      <h2 v-scroll:reveal class="section__legend">{{ $t('post.latest.legend') }}</h2>
      <h3 v-scroll:reveal="{ delay: 75 }" class="section__title">
        {{ $t('post.latest.title') }}
      </h3>
      <div class="section__latest-articles">
        <div
          v-for="latest_post in latest_posts"
          :key="`post-${latest_post.id}-card`"
          class="section__single-article"
        >
          <PostCard :post="latest_post" class="card-articles -latest-articles" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PostCard from '@/components/cards/PostCard.vue'
import Icon from '@/components/global/Icon.vue'
import Image from '@/components/global/Image.vue'
import LangRouterLink from '@/components/global/LangRouterLink.vue'
import RawHtml from '@/components/global/RawHtml.vue'
import { formatDate } from '@/helpers/dateHelpers.js'
import { setMeta } from '@/helpers/metaHelpers.js'

export default {
  name: 'ArticleSingle',
  components: {
    Image,
    PostCard,
    Icon,
    LangRouterLink,
    RawHtml,
  },
  props: {
    slug: {
      type: String,
      default: null,
    },
  },
  setup: () => ({ formatDate }),
  data: () => ({
    post: null,
  }),
  computed: {
    hasShare() {
      return navigator && navigator.share && !this.$mq.md
    },
    latest_posts() {
      return this.$store.getters.posts
        .filter((post) => post.id.toString() !== this.post.id.toString())
        .slice(0, 2)
    },
    shareUrl() {
      return window.location.href
    },
  },
  methods: {
    shareSocials(provider) {
      const platforms = {
        facebook: [
          `https://facebook.com/sharer/sharer.php?u=${window.location.href}`,
          '_blank',
          'fullscreen=no, width=500, height=700, toolbar=no, status=no, titlebar=no,left=500px',
        ],
        linkedin: [
          `https://www.linkedin.com/sharing/share-offsite/?summary=${this.post.title}&url=${
            window.location.href
          }`,
          '_blank',
          'fullscreen=no, width=500, height=700, toolbar=no, status=no, titlebar=no,left=500px',
        ],
      }
      window.open(...platforms[provider])
    },
    shareNavigator() {
      if (navigator.share) {
        navigator.share({
          title: this.title,
          url: window.location.href,
        })
      }
    },
  },
  mounted() {
    this.$store.dispatch('loadPosts')
  },
  watch: {
    '$route.params.slug': {
      async handler(slug) {
        this.post = null
        this.$store
          .dispatch('fetchPost', slug.split('-').at(-1))
          .then((post) => (this.post = post))
          .then(() => {
            if (!this.post) return
            setMeta({
              description: this.post.summary,
              image: this.post.image,
              title: this.post.title + ' | CRH Canada',
            })
          })
          .catch(() => this.$router.push({ name: 'post.index' }))
      },
      immediate: true,
    },
  },
}
</script>
